// MetricCard: tiny uppercase label, big tabular value, one secondary line (trend ▲/▼ and/or meta). DESIGN §2/§3.
import './metric-card.css';
import { Icon } from '../icons.jsx';
import { cx } from './ui.jsx';

const defaultDelta = (d) => `${d > 0 ? '+' : ''}${Math.round(d * 10) / 10}%`;

// Trend chip: ↗ +12% (positive) / ↘ −4% (danger); `invert` = lower is better (e.g. review speed).
export function Delta({ value, format = defaultDelta, invert = false, class: cls }) {
  if (value == null || !Number.isFinite(value)) return null;
  const up = value > 0;
  const flat = value === 0;
  const good = flat ? null : invert ? !up : up;
  return (
    <span class={cx('delta', good === true && 'is-good', good === false && 'is-bad', cls)}>
      {!flat && <Icon name={up ? 'arrowUpRight' : 'arrowDownRight'} size={13} />}
      {format(value).replace('-', '−')}
    </span>
  );
}

// label: 'ACTIVE BATCHES'-style tiny label (any case; shown uppercase). value: number/string (null → '—').
// delta: signed number shown as a trend (deltaFormat, invert). meta: secondary text; metaTone: 'danger'|'positive'|…
// href: whole card is a link. size: 'md' (default, 28px value) | 'sm' (22px value). icon: optional small glyph.
export function MetricCard({ label, value, delta, deltaFormat, invert, meta, metaTone, href, size = 'md', icon, class: cls, children }) {
  const Tag = href ? 'a' : 'div';
  const hasSecondary = (delta != null && Number.isFinite(delta)) || (meta != null && meta !== '');
  return (
    <Tag class={cx('metric', size === 'sm' && 'metric-sm', href && 'is-link', cls)} href={href}>
      <span class="metric-label">
        {icon && <Icon name={icon} size={14} />}
        {label}
      </span>
      <span class="metric-value">{value ?? '—'}</span>
      {hasSecondary && (
        <span class="metric-sub">
          <Delta value={delta} format={deltaFormat} invert={invert} />
          {meta != null && meta !== '' && <span class={cx('metric-meta', metaTone && `text-${metaTone}`)}>{meta}</span>}
        </span>
      )}
      {children}
    </Tag>
  );
}
